import React from 'react';
import {NavLink} from 'react-router-dom';
import './Tabbar.scss';

export default class Tabbar extends React.Component{
    constructor(props){
        super(props);
        this.searchString = props.search;
    }

    render() {
        return (
            <nav className="m-tabBar">
                <NavLink exact to={ {pathname: "/", search: this.searchString} }  className="item clickstat" data-stat="Click/hometab|点击/首页tab">
                    <i className="u-icon u-icon-tabBar-index"></i>
                    <span className="txt">首页</span>
                </NavLink>
                <NavLink  to={ {pathname: "/subscriber", search: this.searchString} } className="item clickstat" data-stat="Click/subtab|点击/订阅tab">
                    <i className="u-icon u-icon-tabBar-sub"></i>
                    <span className="txt">订阅</span>
                </NavLink>
            </nav>
        );
    }
}




// WEBPACK FOOTER //
// ./src/common/components/tabbar/Tabbar.jsx